import EditIcon from "../../../../../assets/icons/EditIcon"
import ClockRotateIcon from "../../../../../assets/icons/ClockRotateIcon"
import styles from "./index.module.scss"

export const TabEditAndHistory = ({ isTabEdit, handleActive }) => {
  return (
    <div className={styles.flexColumn}>
      <div className={styles.containerEditAndHistory}>
        <span
          className={isTabEdit ? styles.active : styles.desactive}
          onClick={() => handleActive(true)}
        >
          <EditIcon />
          EDITAR
        </span>
        <span
          className={!isTabEdit ? styles.active : styles.desactive}
          onClick={() => handleActive(false)}
        >
          <ClockRotateIcon flll="#6cb6e3" />
          HISTÓRICO
        </span>
      </div>
    </div>
  )
}
